var _path, _rect, _path2, _rect2, _rect3, _path3, _rect4, _rect5, _path4, _rect6, _rect7, _path5, _rect8, _rect9, _path6, _rect0, _rect1, _path7, _rect10, _rect11, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendanceTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4L1 5V34H42V5H38V4H35V5H8V4H5V5H1L0 4H43V35H0V4Z",
    fill: ""
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 41,
    height: 1,
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 13H38V21L37 20V14H29V20H37L38 21H28V13Z",
    fill: ""
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1426,
    y: 15.9058,
    width: 1,
    height: 5.04742,
    transform: "rotate(-53.0158 31.1426 15.9058)",
    fill: ""
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1777,
    y: 15.1102,
    width: 1,
    height: 5.04742,
    transform: "rotate(53.1249 35.1777 15.1102)",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23H27V31L26 30V24H18V30H26L27 31H17V23Z",
    fill: ""
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.002,
    y: 25.7988,
    width: 1,
    height: 5.04742,
    transform: "rotate(-53.0158 20.002 25.7988)",
    fill: ""
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0371,
    y: 25.0033,
    width: 1,
    height: 5.04742,
    transform: "rotate(53.1249 24.0371 25.0033)",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23H16V31L15 30V24H7V30H15L16 31H6V23Z",
    fill: ""
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1289,
    y: 25,
    width: 1,
    height: 5.28124,
    rx: 0.5,
    transform: "rotate(44.9942 13.1289 25)",
    fill: ""
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27.8068,
    width: 1,
    height: 2.6164,
    rx: 0.5,
    transform: "rotate(-47.7226 8 27.8068)",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13H16V21L15 20V14H7V20H15L16 21H6V13Z",
    fill: ""
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1289,
    y: 15,
    width: 1,
    height: 5.28124,
    rx: 0.5,
    transform: "rotate(44.9942 13.1289 15)",
    fill: ""
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17.8068,
    width: 1,
    height: 2.6164,
    rx: 0.5,
    transform: "rotate(-47.7226 8 17.8068)",
    fill: ""
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13H27V21L26 20V14H18V20H26L27 21H17V13Z",
    fill: ""
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1289,
    y: 15,
    width: 1,
    height: 5.28124,
    rx: 0.5,
    transform: "rotate(44.9942 24.1289 15)",
    fill: ""
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 17.8068,
    width: 1,
    height: 2.6164,
    rx: 0.5,
    transform: "rotate(-47.7226 19 17.8068)",
    fill: ""
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28 23H38V31L37 30V24H29V30H37L38 31H28V23Z",
    fill: ""
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1289,
    y: 25,
    width: 1,
    height: 5.28124,
    rx: 0.5,
    transform: "rotate(44.9942 35.1289 25)",
    fill: ""
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 27.8068,
    width: 1,
    height: 2.6164,
    rx: 0.5,
    transform: "rotate(-47.7226 30 27.8068)",
    fill: ""
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 0H8V6L7 5V1H6V5H7L8 6H5V0Z",
    fill: ""
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H38V6L37 5V1H36V5H37L38 6H35V0Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceTracker);
export default __webpack_public_path__ + "static/media/attendance-tracker.7e6eece593dbc8c3e1ead6831f2eb5d4.svg";
export { ForwardRef as ReactComponent };